function onLongTouch(
    $mdMedia,
    $parse,
    $timeout
) {
    return {
        restrict: "A",
        link: (scope, elem, attrs)  => {
            let timeoutHandler;
            const fn = $parse(attrs.onLongTouch);

            // disable text selection on mobile
            if ($mdMedia("xs")) {
                elem.unselectable = "on";
                elem.addClass("unselectable");
            }

            elem.bind(
                "touchstart",
                event => {
                    scope.longTouchTriggered = false;
                    timeoutHandler = $timeout(
                        () => {
                            scope.longTouchTriggered = true;
                            fn(scope, {$event: event});
                        },
                        200
                    );
                });

            elem.bind(
                "touchend",
                () => {
                    if (scope.longTouchTriggered) {
                        event.preventDefault();
                    }
                    $timeout.cancel(timeoutHandler);
                });

            elem.bind(
                "touchmove",
                () => {
                    $timeout.cancel(timeoutHandler);
                });
        }
    };
}

onLongTouch.$inject = [
    "$mdMedia",
    "$parse",
    "$timeout"
];

angular
    .module("thor.core.onLongTouch.directive", [])
    .directive("onLongTouch", onLongTouch);
